export const TIPS_STATEMENT_FILTER_QUERY_PARAM = 'filter';

export const TIPS_STATEMENT_FILTER_VALUES = [
  'all',
  'incoming',
  'withdrawals',
] as const;

export type TipsStatementFilter = (typeof TIPS_STATEMENT_FILTER_VALUES)[number];

export type TipsStatementTransactionTypeFilter = 'tip' | 'withdrawal';

function isTipsStatementFilter(value: string): value is TipsStatementFilter {
  return TIPS_STATEMENT_FILTER_VALUES.some(filter => filter === value);
}

export function parseTipsStatementFilter(
  value: string | null,
): TipsStatementFilter {
  if (!value) {
    return 'all';
  }

  if (isTipsStatementFilter(value)) {
    return value;
  }

  return 'all';
}

export function resolveTipsStatementTransactionTypeFilter(
  filter: TipsStatementFilter,
): TipsStatementTransactionTypeFilter | undefined {
  if (filter === 'incoming') {
    return 'tip';
  }

  if (filter === 'withdrawals') {
    return 'withdrawal';
  }

  return undefined;
}
